import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// MUI Icons
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import SouthEastIcon from "@mui/icons-material/SouthEast";

// Custom
import useRouting from "@/components/MapRouting/useRouting";
import { GridContainer, GridItem } from "@/ui/Grid";

const MapRouteInfo = () => {

  const { routeData } = useRouting({});
  const { t } = useTranslation();

  return (routeData ?
    <GridContainer spacing={1}>
      <GridItem size={3}>
        <Stack>
          <SettingsEthernetIcon fontSize="medium" color="primary" />
          <Typography
            color="primary"
            variant="h6"
            sx={{ py: "2px", letterSpacing: "-0.5px" }}
          >{`${routeData.record.total_length as number} m`}</Typography>
          <Typography variant="caption">
            {t("route.duljina") as string}
          </Typography>
        </Stack>
      </GridItem>
      <GridItem size={3}>
        <Stack>
          <AccessTimeIcon fontSize="medium" color="primary" />
          <Typography
            color="primary"
            variant="h6"
            sx={{ py: "2px", letterSpacing: "-0.5px" }}
          >
            {routeData.record.total_time as string}
          </Typography>
          <Typography variant="caption">
            {t("route.trajanje") as string}
          </Typography>
        </Stack>
      </GridItem>
      <GridItem size={3}>
        <Stack>
          <NorthEastIcon fontSize="medium" color="primary" />
          <Typography
            color="primary"
            variant="h6"
            sx={{ py: "2px", letterSpacing: "-0.5px" }}
          >{`${routeData.record.total_ascent as number} m`}</Typography>
          <Typography variant="caption">
            {t("route.elevation_gain") as string}
          </Typography>
        </Stack>
      </GridItem>
      <GridItem size={3}>
        <Stack>
          <SouthEastIcon fontSize="medium" color="primary" />
          <Typography
            color="primary"
            variant="h6"
            sx={{ py: "2px", letterSpacing: "-0.5px" }}
          >{`${routeData.record.total_descent as number} m`}</Typography>
          <Typography variant="caption">
            {t("route.elevation_loss") as string}
          </Typography>
        </Stack>
      </GridItem>
    </GridContainer>
    : null
  );
}

export default MapRouteInfo;
